import { render } from "./inform.vue?vue&type=template&id=434ab062&scoped=true"
import script from "./inform.vue?vue&type=script&lang=js"
export * from "./inform.vue?vue&type=script&lang=js"

import "./inform.vue?vue&type=style&index=0&id=434ab062&lang=scss&scoped=true"
import "./inform.vue?vue&type=style&index=1&id=434ab062&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434ab062"]])

export default __exports__